export interface FlowUsageResponse {
  sandbox: FlowUsage;
  production: FlowUsage;
  isFlowInProd: Boolean;
}

export interface FlowUsage {
  flows: FlowReference[];
  keywords: { [key: string]: number };
  routes: { [key: string]: string[] };
}

export interface FlowReference {
  flowId: string;
  flowPath: string;
  flowSteps: string[];
}
